// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5604 ? "7cb1fa1f" : chunkId) + "." + {"1935":"8493eb08b1577dc6","5604":"b154f0c651057632"}[chunkId] + ".js";
};